const items = [
    "Recovery",
    "Knowledge",
    "Real Change",
    "Break the Cycle",
    "Understand Addiction",
    "Build a Path Forward",
    "Faith",
    "Hope",
];

export const Marquee = () => (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#C9A227]/20 bg-[#08162A] py-4">
        <div className="marquee-track flex w-max items-center gap-10">
            {[...items, ...items].map((t, i) => (
                <span
                    key={i}
                    className="flex items-center gap-10 whitespace-nowrap text-xs sm:text-sm font-semibold uppercase tracking-[0.35em] text-[#C9A227]/80"
                >
                    {t}
                    <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#C9A227]/50" />
                </span>
            ))}
        </div>
    </div>
);
